import { useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

import Header from './Header';
import StructuresTab from '../features/structures/StructuresTab';
import InputsTab from '../features/inputs/InputsTab';
import UserManagement from '../features/users/UserManagement';
import StyleShowcase from '../styles/showcase/StyleShowcase';

export default function MainLayout() {
  const theme = useTheme();
  const [currentView, setCurrentView] = useState('structures');

  const handleViewChange = (newView) => {
    setCurrentView(newView);
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'users':
        return <UserManagement />;
      case 'structures':
        return <StructuresTab />;
      case 'computations':
        return <InputsTab />;
      case 'analysis':
        return (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%',
            flexDirection: 'column',
            gap: theme.spacing(3),
            backgroundColor: theme.palette.grey[50]
          }}>
            <ConstructionIcon sx={{ 
              fontSize: theme.dimensions.icon.large * 2.5, 
              color: theme.palette.grey[400],
              mb: theme.spacing(1)
            }} />
            <Typography variant="h4" sx={{ 
              color: theme.palette.grey[700],
              fontWeight: theme.typography.fontWeight.medium,
              fontSize: theme.typography.fontSize.xl,
              mb: theme.spacing(1)
            }}>
              Under Construction
            </Typography>
            <Typography variant="body1" sx={{ 
              color: theme.palette.grey[600],
              textAlign: 'center',
              maxWidth: 400,
              fontSize: theme.typography.fontSize.base,
              lineHeight: 1.6
            }}>
              Analysis tab is currently being developed. This will contain tools for analyzing computational results.
            </Typography>
            <Typography variant="body2" sx={{ 
              mt: theme.spacing(3),
              color: theme.palette.text.disabled,
              fontSize: theme.typography.fontSize.sm,
              fontStyle: 'italic'
            }}>
              🚧 Coming Soon
            </Typography>
          </Box>
        );
      case 'styles':
        return <StyleShowcase />;
      default:
        return <StructuresTab />;
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100vh', 
      overflow: 'hidden'
    }}>
      <Header 
        currentView={currentView}
        onViewChange={handleViewChange}
      />
      <Box sx={{ 
        flex: 1,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {renderCurrentView()}
      </Box>
    </Box>
  );
}